export default {
  "name": "Nine Times And More",
  "slug": "nine-times-and-more",
  "path": "/nine-times-and-more",
  "componentName" : "NineTimesAndMore",
  "category": "Projects",
  "parent": false,
  "isPublic": true
}